/**
 * Formats a number to a specific punctuation, defaults to German style
 * f.e.: 13000.25 to 13.000,25
 * @param {number} number floating-point number
 * @param {number} decimals integer with count of decimals
 * @param {string} decimalSeparator string with decimal separator
 * @param {string} thousandsSeparator string with thousands separator
 * @returns {string}
 */
export function formatNumber(
  number,
  decimals,
  decimalSeparator = ',',
  thousandsSeparator = '.',
) {
  const numberParts = number.toFixed(decimals).split('.');

  // Regex explanation: https://regex101.com/r/nOwEOw/1/
  return numberParts[0].replace(
      /(\d)(?=(\d{3})+(?!\d))/g,
      `$1${thousandsSeparator}`,
    ) + (decimals > 0 ? decimalSeparator + numberParts[1] : '');
}
